import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Customer, CustomerStatus } from './customer-models';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
              @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/customer`;
  }

  getCustomerList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Customer>> {
    return this.httpClient.get<AutoTablePageableResponse<Customer>>(`${this._baseURL}s`, {
      params
    });
  }

  getCustomer(username: string): Observable<Customer> {
    return this.httpClient.get<Customer>(`${this._baseURL}/${username}`);
  }

  newCustomer(customer: Customer): Observable<Customer> {
    return this.httpClient.post<Customer>(`${this._baseURL}`, customer);
  }

  updateCustomer(customer: Customer): Observable<Customer> {
    return this.httpClient.put<Customer>(`${this._baseURL}/${customer.username}`, customer);
  }

  removeCustomer(username: string | string[]): Observable<any> {
    if (!_.isArray(username)) {
      return this.httpClient.delete(`${this._baseURL}/${username}`);
    } else {
      return this.httpClient.delete(`${this._baseURL}`, {
        params: {
          username
        }
      });
    }
  }

  updateCustomerStatus(username: string | string[], status: CustomerStatus): Observable<any> {
    if (!_.isArray(username)) {
      return this.httpClient.patch(`${this._baseURL}/${username}`, {}, {
        params: {
          status
        }
      });
    } else {
      return this.httpClient.patch(`${this._baseURL}`, {}, {
        params: {
          username,
          status
        }
      });
    }
  }

  resetPassword(username: string): Observable<Customer> {
    return this.httpClient.patch<Customer>(`${this._baseURL}/${username}`, {}, {
      params: {
        reset: 'true'
      }
    });
  }
}
